import { ParamsService } from '../services'

const excelCategoriasDelitos = (params = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await ParamsService.excelCategoriasDelitos(params)
      resolve(response)
    } catch (error) {
      reject({ error: true, message: error.message })
    }
  })
}

export default excelCategoriasDelitos